import type { TemplateResourceListResponseFront } from '../../models/applicationVersion.model';

export function mapSystemPackagesVersionTemplatesById(
  data: TemplateResourceListResponseFront,
): TemplateResourceListResponseFront {
  return {
    pagination: data.pagination,
    data: data.data.map((template) => ({
      componentType: template?.componentType,
      createdBy: template?.createdBy,
      creationDate: template?.creationDate,
      description: template?.description,
      id: template?.id,
      name: template?.name,
      targetLocation: template?.targetLocation,
      templateFileId: template?.templateFileId,
      templateFileName: template?.templateFileName,
      templateFileVersion: template?.templateFileVersion,
    })),
  };
}
